<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$test"
				start
			/>
			Order Simulation
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col cols="8">
					<p>Create a test order for the given email address.</p>
					<p><em>Warning:</em> Email will be sent to this email address, so be careful what you enter here.</p>
					<p><em>Warning:</em> Using an already known email address will create a new order for the existing client.</p>
					<p>The provided data should all be valid for now, modify fields to test failure conditions</p>
				</v-col>
				<v-col cols="4">
					<v-select
						v-model="domain"
						label="Select a domain for which the order will be created"
						:items="select.domains"
						item-title="name"
						return-object
						variant="outlined"
						@update:model-value="updateDomain"
					/>
				</v-col>
			</v-row>
			<v-container
				v-if="address.country"
				class="px-16"
			>
				<v-row class="px-3">
					<v-col
						cols="6"
						class="pr-16"
					>
						<v-text-field
							v-model="fields.email"
							:label="$gettext('Email')"
							variant="outlined"
						/>
						<v-text-field
							v-model="fields.initials"
							:label="$gettext('Initials')"
							variant="outlined"
						/>
						<v-text-field
							v-model="fields.firstName"
							:label="$gettext('First Name')"
							variant="outlined"
						/>
						<v-text-field
							v-model="fields.infix"
							:label="$gettext('Infix')"
							variant="outlined"
						/>
						<v-text-field
							v-model="fields.lastName"
							:label="$gettext('Last Name')"
							variant="outlined"
						/>
						<v-text-field
							v-model="fields.gender"
							:label="$gettext('Gender')"
							variant="outlined"
						/>
						<v-text-field
							v-model="fields.birthDate"
							:label="$gettext('Birth Date')"
							variant="outlined"
						/>
						<v-text-field
							v-model="fields.telephoneNumber"
							:label="$gettext('Telephone Number')"
							variant="outlined"
						/>
						<v-select
							v-model="fields.language"
							:items="select.languages"
							:label="$gettext('Language')"
							variant="outlined"
						/>
						<v-text-field
							v-model="fields.iban"
							:label="$gettext('IBAN')"
							variant="outlined"
						/>
					</v-col>
					<v-col
						cols="6"
						class="pl-16"
					>
						<v-text-field
							v-model="fields.ean"
							:label="$gettext('EAN')"
							variant="outlined"
						/>
						<device-name-search
							:label="$gettext('Device')"
							endpoint="/bo/testing/testorders/devices"
							:initialise-value="true"
							variant="outlined"
							@input="(deviceId) => {fields.device = deviceId}"
						/>
						<v-text-field
							v-model="fields.orderReference"
							:label="$gettext('Order Reference')"
							variant="outlined"
						/>
						<v-text-field
							v-model="fields.imei"
							:label="$gettext('IMEI')"
							variant="outlined"
						/>
						<v-text-field
							v-model="fields.purchasePrice"
							:label="$gettext('Purchase Price')"
							variant="outlined"
						/>
						<v-text-field
							v-model="fields.phonePurchaseDate"
							:label="$gettext('Phone Purchase Date')"
							variant="outlined"
						/>
						<v-select
							v-model="fields.pointOfSale"
							:items="select.pointOfSales"
							:label="$gettext('Point of Sale')"
							variant="outlined"
						/>
						<v-select
							v-model="fields.productVersion"
							:items="select.productVersions"
							:label="$gettext('Product Version')"
							:error-messages="errors.productVersion"
							variant="outlined"
						/>
						<v-text-field
							v-model="fields.sellerName"
							:label="$gettext('Seller')"
							variant="outlined"
						/>
						<v-text-field
							v-model="fields.insuranceStartDate"
							:label="$gettext('Insurance Start Date')"
							variant="outlined"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<address-fields
							v-model="address"
							:country-name="domain.country.countryName"
							variant="outlined"
						/>
					</v-col>
				</v-row>
			</v-container>
		</v-card-text>
		<v-card-actions v-if="address.country">
			<v-spacer />
			<v-btn
				color="primary"
				@click="createTestOrder"
			>
				<translate>Create Test Order</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../../../services/axios-service';
import {
	displayError, inform,
} from 'laravel-front-library';
import {
	debounce, toLower,
} from 'lodash';

export default {
	name: 'CreateTestOrder',
	data () {
		return {
			fields: {
				email: null,
				initials: 'T.D.',
				firstName: 'Turbo',
				infix: 'van',
				lastName: 'Testmaan',
				gender: 'M',
				birthDate: '01-10-1970',
				language: 'nl',
				telephoneNumber: '+31682898367',
				iban: 'NL40ABNA7819947683',
				ean: null,
				device: null,
				productVersion: null,
				orderReference: null,
				imei: null,
				purchasePrice: '12345',
				phonePurchaseDate: '01-01-2019',
				pointOfSale: null,
				sellerName: 'Test Seller',
				insuranceStartDate: this.today()
			},
			address: {
				country: null,
			},
			errors: {
				productVersion: null
			},
			domain: null,

			select: {
				domains: [],
				languages: [],
				productVersions: [],
				domainProductVersions: {
				},
				pointOfSales: []
			},

			domainAddresses: {
				NL: {
					street: 'Testlaan',
					housenumber: '15',
					housenumberSuffix: 'A',
					postalcode: '9712JD',
					city: 'TestMan',
				},
				BE: {
					street: 'Testlaan',
					housenumber: '15',
					postalcode: '8700',
					city: 'TestMan',
				},
				DE: {
					street: 'Teststrasse',
					housenumber: '66',
					postalcode: '12345',
					city: 'TestMan',
				},
				IE: {
					street: 'Test Street',
					housenumber: '5',
					city: 'TestMan',
				},
				AT: {
					street: 'Teststrasse',
					housenumber: '20',
					postalcode: '7800',
					city: 'TestMan',
				},
				FR: {
					street: 'Rue du Moulin',
					housenumber: '153',
					postalcode: '54321',
					city: 'TestMan',
				},
				ES: {
					street: 'Avenida',
					housenumber: '4',
					postalcode: '78910',
					city: 'TestMan',
				},
			}
		};
	},

	mounted () {
		this.getTestData().then(() => {
			this.getDomains();
		});
	},

	methods: {
		/**
		 * Today's date as d-m-Y
		 *
		 * @returns {string}
		 */
		today () {
			const date = new Date();

			return date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
		},

		/**
		 * Get valid select options for test data and generate random order data
		 *
		 * @returns {Promise}
		 */
		getTestData () {
			return new Promise((resolve) => {
				axios.get('testorders/selections').then(({
					data: select
				}) => {
					this.select.languages = select.languages;
					this.select.domainProductVersions = select.productVersions;
					this.select.pointOfSales = select.pointOfSales;
					if (this.select.pointOfSales.length > 0) {
						this.fields.pointOfSale = this.select.pointOfSales[0];
					}

					axios.get('testorders/testdata').then(({
						data: data
					}) => {
						this.fields = {
							...this.fields, ...data
						};
					}).catch((error) => {
						displayError('Something has gone wrong during data retrieval');
						window.captureException(error);
					}).finally(() => {
						resolve();
					});
				}).catch((error) => {
					displayError('Something has gone wrong during data retrieval');
					window.captureException(error);
				});
			});
		},

		/**
		 * Get the available domains
		 *
		 * @returns {void}
		 */
		getDomains () {
			axios.get('/api/v0/domains').then(({
				data: data
			}) => {
				this.select.domains = data;
			}).catch((error) => {
				displayError('Something has gone wrong during data retrieval');
				window.captureException(error);
			});
		},

		/**
		 * Update the component for the selected domain
		 *
		 * @returns {void}
		 */
		async updateDomain () {
			const lowerDomain = toLower(this.domain.name);

			this.fields.email = 'test@belsimpel.' + lowerDomain;
			this.select.productVersions = Object.hasOwn(this.select.domainProductVersions, lowerDomain) ?
				this.select.domainProductVersions[lowerDomain] :
				[];
			if (this.select.productVersions.length > 0) {
				this.fields.productVersion = this.select.productVersions[0];
				this.errors.productVersion = '';
			} else {
				this.errors.productVersion = 'No active product versions for the selected domain';
			}
			this.address = {
				country: this.domain.country.countryCode
			};
			this.address = {
				...this.address,
				...(Object.hasOwn(this.domainAddresses, this.domain.name) ?
					this.domainAddresses[this.domain.name] :
					this.domainAddresses.NL)
			};
		},

		/**
		 * Create the test order using the current data
		 *
		 * @returns {void}
		 */
		createTestOrder () {
			const formData = new FormData();
			const orderData = {
				...this.fields, ...this.address
			};

			for (const field in orderData) {
				formData.append(field, orderData[field]);
			}
			axios.post('testorders/createtestorder', formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}).then(() => {
				inform('Test order created');
				debounce(() => {
					window.location.href = '/bo/orders';
				}, 1000)();
			}).catch((error) => {
				displayError(error.response.data.messages);
				window.captureException(error);
			});
		}
	}
};
</script>

<style scoped>
</style>
